<template>
  <v-dialog v-model="visibility" persistent max-width="410px" content-class="elevation-0 rounded-xl" overlay-color="#000000" overlay-opacity="0.4">
    <v-card class="pa-8">
      <div v-if="loading">
        <v-row no-gutters align="center" justify="center" class="pb-4">
          <v-progress-circular indeterminate size="48" color="#e22925"></v-progress-circular>
        </v-row>
        <v-row no-gutters class="dialog-text" justify="center">Preparing your call now,</v-row>
        <v-row no-gutters class="dialog-text" justify="center">just a few seconds...</v-row>
      </div>
      <div v-else-if="is_success">
        <v-row no-gutters align="center" justify="center" class="pb-4"> <v-icon x-large color="#27AE60">mdi-phone-outgoing</v-icon> </v-row>
        <v-row no-gutters class="dialog-text" justify="center">We’re calling your number now</v-row>
        <v-row no-gutters class="dialog-subtext" justify="center">You’ll receive the call within 1 minute</v-row>
        <v-row no-gutters class="pt-4" justify="center">
          <v-btn small class="rounded-xl text-capitalize pa-4 confirm-button" color="#e22925" height="36px" @click="$store.commit('RESET_LOAD_CALL_DIALOG')"> Done </v-btn>
        </v-row>
      </div>
      <div v-else-if="success">
        <v-row no-gutters align="center" justify="center" class="pb-4"> <v-icon x-large color="#e22925">mdi-close-circle-outline</v-icon> </v-row>
        <v-row no-gutters class="dialog-text" justify="center">{{ success.message }}</v-row>
        <v-row no-gutters class="pt-4" justify="center">
          <v-btn small class="rounded-xl text-capitalize pa-4 confirm-button" color="#e22925" height="36px" @click="$store.commit('RESET_LOAD_CALL_DIALOG')"> Close </v-btn>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LoadCallDialog',
  computed: {
    ...mapState(['loadCallDialog']),
    visibility() {
      return this.loadCallDialog.visibility
    },
    loading() {
      return this.loadCallDialog.loading
    },
    success() {
      return this.loadCallDialog.success
    },
    is_success() {
      return this.success?.success === 'success'
    }
  }
}
</script>

<style scoped>
.confirm-button {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
}

.dialog-text {
  font-weight: 400;
  font-size: 24px;
  line-height: 150%;
  text-align: center;
  color: #808080;
}

.dialog-subtext {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #808080;
}
</style>
